import { useEffect, useState } from "react";
import { db } from "../../firebaseConfig"; 
import { collection, getDocs, deleteDoc, doc } from "firebase/firestore";
import { Table, TableBody, TableCell, TableHead, TableRow, Button, TextField } from "@mui/material";
import * as XLSX from "xlsx";

export default function InventoryTable() {
  const [refacciones, setRefacciones] = useState([]);
  const [search, setSearch] = useState("");

  const fetchData = async () => {
    const res = await getDocs(collection(db, "refacciones"));
    const data = res.docs.map(doc => ({ id: doc.id, ...doc.data() }));
    setRefacciones(data);
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleDelete = async (id) => {
    await deleteDoc(doc(db, "refacciones", id));
    fetchData();
  };

  const exportToExcel = () => {
    // Crear un nuevo arreglo con los datos que deseas exportar, reemplazando el id por el codigoBarras
    const modifiedData = refacciones.map(({ id, codigoBarras, ...rest }) => ({
      ...rest, // Conserva las demás propiedades
      codigoBarras, // Reemplaza el id por el codigoBarras
    }));
  
    const ws = XLSX.utils.json_to_sheet(modifiedData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Refacciones");
    XLSX.writeFile(wb, "Inventario.xlsx");
  };
  

  const filtered = refacciones.filter(r => {
    const nombre = r.nombre ? r.nombre.toLowerCase() : ''; // Asegúrate de que nombre no sea undefined o null
    const codigoBarras = r.codigoBarras ? r.codigoBarras.toLowerCase() : ''; // Asegúrate de que codigoBarras no sea undefined o null
  
    return nombre.includes(search.toLowerCase()) || codigoBarras.includes(search.toLowerCase());
  });
  

  return (
    <>
      <TextField
        label="Buscar por nombre o escaneo"
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        sx={{ mb: 2 }}
        fullWidth
      />
      <Button onClick={exportToExcel} sx={{ mb: 2 }} variant="outlined">Exportar a Excel</Button>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Nombre</TableCell>
            <TableCell>Descripción</TableCell>
            <TableCell>Cantidad</TableCell>
            <TableCell>Precio</TableCell>
            <TableCell>Código de Barras</TableCell>
            <TableCell>Acciones</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {filtered.map((r) => (
            <TableRow key={r.id}>
              <TableCell>{r.nombre}</TableCell>
              <TableCell>{r.descripcion}</TableCell>
              <TableCell>{r.cantidad}</TableCell>
              <TableCell>${r.precioVenta}</TableCell>
              <TableCell>{r.codigoBarras}</TableCell>
              <TableCell>
                <Button onClick={() => handleDelete(r.id)} color="error">Eliminar</Button>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </>
  );
}